import HttpService from "service/web/HttpService";
import CookieService from "../CookieService";
import {initialiseStores, userStore} from "stores";
import {action} from "mobx";

export default class AuthWebService {

    static changePasswordWithToken = async (token, newPassword) => {
        await HttpService.postAsync('/auth/change-password-token', {token, newPassword});
    }

    static updateUser = async (user) => {
        await HttpService.postAsync('/auth/update-account', user);
    }

    static isFreeUser() {
        return true;
    }

    static isPremiumUser() {
        return false;
    }

    static logIn = async (email, password) => {
        const response = await HttpService.postAsync('/login', {email, password})
        await CookieService.set('token', response.headers.authorization);
        await initialiseStores();
    }

    // Returns true when the key authenticated and the stores initialised; false when the key was
    // rejected (e.g. an expired signing link), so callers can offer link renewal instead of spinning.
    static authenticateWithKey = async (key) => {
        const token = "Temp_" + key;
        const currentToken = CookieService.get('token');
        if (currentToken !== token) {
            await CookieService.set('token', token);
            await initialiseStores();
        }
        return userStore.initialised;
    }

    static logOut = async () => {
        action (() => userStore.redirectLink = null)();
        CookieService.remove('token', '/');
        await initialiseStores();
    }

    static recover = async (email) => {
        await HttpService.postAsync('/auth/recover', {email});
    }

    static register = async (user) => {
        return HttpService.postAsync('/auth/register', user);
    }

    static verifyAccount = async (token) => {
        return HttpService.getAsync('/auth/verify/' + token);
    }

    static uploadProfileImage = async (id, image) => {
        return HttpService.postAsync('/auth/profile-image', {id, image}).then(r => r.data);
    }
}